import React from 'react';

interface NotificationIconProps {
  unreadCount: number;
  isOpen: boolean;
  onClick: () => void;
}

export const NotificationIcon = React.memo(function NotificationIcon({
  unreadCount,
  isOpen,
  onClick,
}: NotificationIconProps) {
  return (
    <button
      className={`main-header__notif${isOpen ? ' main-header__notif--open' : ''}`}
      type="button"
      aria-label={unreadCount > 0 ? `Notifications - ${unreadCount} unread` : 'Notifications'}
      aria-pressed={isOpen}
      onClick={onClick}
    >
      <span className="material-symbols-outlined">notifications</span>
      {unreadCount > 0 && (
        <span className="main-header__notif-badge" aria-hidden="true">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
});
